exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".purchasing-process{background-color:#f7f7f7;font-size:1.25rem;font-weight:100}.purchasing-process .container{max-width:900px}.purchasing-process .container .step-name{text-align:center}@media(min-width: 768px){.purchasing-process .container .step-name{text-align:left}}.purchasing-process .container .icon-wrapper{border-radius:50%;padding:1.9rem;width:125px;height:125px}.purchasing-process .container .icon-wrapper .MuiSvgIcon-root{font-size:3.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/LandingPages/PurchasingProcess/PurchasingProcess.scss
// module id = 7702
// module chunks = 13